import script from "./child_sub_card.vue?vue&type=script&setup=true&lang=js"
export * from "./child_sub_card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__